'use client';
import styled from 'styled-components';

export const SocialMediaContainer = styled.div`
  display: flex;
  margin-top: 40px;
  gap: 16px;
  justify-content: flex-end;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    justify-content: center;
  }
`;

export const SocialMediaLink = styled.a`
  color: ${({ theme }) => theme.palette.grey800};
  transition: color 0.2s ease-in-out;
  width: 24px;
  height: 24px;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.palette.grey1100};
  }
`;
